import { Component, EventEmitter, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Article, MenuItemWithArticle } from 'segov-sigepo-ui-component/projects/segov-sigepo-component/src/lib/controls/segov-sigepo-side-menu-with-body/segov-sigepo-side-menu-with-body.component';
import { SegovPage } from 'src/app/app.routes';
import { LinkClickable, SegovSigepoHeaderSectionComponent } from 'src/app/controls/segov-sigepo-header-section/segov-sigepo-header-section.component';
import { SegovSigepoPortalBodyComponent } from 'src/app/controls/segov-sigepo-portal-body/segov-sigepo-portal-body.component';
import { ControlsModule } from 'segov-sigepo-lib';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectDadosObterSobre } from 'src/app/stateManagement/selectors/Sobre/obter-sobre.selector';
import { SobreJornalOutputDto } from 'src/app/domain/DTOs/output/sobre/sobre-jornal.output.dto';
import { obterSobre } from 'src/app/stateManagement/actions/Sobre/obter-sobre.action';
import { TimelineItem } from 'segov-sigepo-ui-component/projects/segov-sigepo-component/src/lib/controls/segov-sigepo-timeline-carousel/segov-sigepo-timeline-carousel.component';
import { ComponentMessages } from 'src/app/utils/component.messages';
import { ActivatedRoute, Router } from '@angular/router';
import { ScreenUtils } from 'src/app/utils/screen.utils';
import { ObterSobreState } from 'src/app/stateManagement/reducers/Sobre/obter-sobre.reducer';

@Component({
  selector: 'app-historia-do-jornal-page',
  standalone: true,
  imports: [
    SegovSigepoPortalBodyComponent,
    SegovSigepoHeaderSectionComponent,
    ControlsModule,
  ],
  templateUrl: './historia-do-jornal-page.component.html',
  styleUrl: './historia-do-jornal-page.component.css'
})
export class HistoriaDoJornalPageComponent implements OnInit, OnDestroy {
  public title = ComponentMessages.conhecaODiario;
  public RouteStack: LinkClickable[] = [
    { title: "Início", route: SegovPage.Inicio },
    { title: "Sobre", route: SegovPage.HistoriaJornal },
    { title: "História do jornal", route: SegovPage.HistoriaJornal }
  ]
  public dados?: SobreJornalOutputDto;
  public menuHistoriaDiario: MenuItemWithArticle[] = [];
  public timelineItems: TimelineItem[] = [];
  public numeroItensPagina = 2;
  public finalizouNovaPesquisa = new EventEmitter<string>();
  public textoRedirecionamentoSideMenu = '';
  private primeiroAcesso = true;
  private subSobre: Subscription;
  private subQueryParams: Subscription;

  constructor(
    private readonly storeObterSobre: Store<{ obterSobreState: ObterSobreState }>,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.subSobre = new Subscription();
    this.subQueryParams = new Subscription();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkResolution();
  }

  ngOnInit(): void {
    this.subQueryParams = this.route.queryParams.subscribe(
      params => {
        if (params['dados'])
          this.textoRedirecionamentoSideMenu = params['dados']
      }
    )
    this.subSobre = this.storeObterSobre.select(selectDadosObterSobre)
      .subscribe(result => {
        this.dados = result?.dados;

        this.menuHistoriaDiario = result?.dados.historiaDiario?.map(x => ({
          topic: x.categoria,
          article: {
            title: x.titulo ?? '',
            contents: x.conteudo ?? [],
          } as Article
        } as MenuItemWithArticle)) ?? [];

        if (this.textoRedirecionamentoSideMenu)
          setTimeout(() => {
            this.finalizouNovaPesquisa.emit(this.textoRedirecionamentoSideMenu);
            ScreenUtils.scrollToId("headersidemenuhistoria");
          }, 50);
        else if (this.menuHistoriaDiario && this.menuHistoriaDiario[0])
          setTimeout(() => {
            this.primeiroAcesso = true;
            this.finalizouNovaPesquisa.emit(this.menuHistoriaDiario[0].topic);
          }, 50);

        this.timelineItems = result?.dados.linhaDoTempo?.map((x, index) => ({
          id: index + 1,
          titulo: x['DataHistorica'],
          descricoes: [x['Descricao']]
        } as TimelineItem)) ?? [];

      });

    this.getDadosSobre();
    this.checkResolution();
  }

  ngOnDestroy(): void {
    this.subSobre.unsubscribe();
    this.subQueryParams.unsubscribe();
    this.primeiroAcesso = true;
  }

  public goToReportagensIconicas() {
    this.router.navigate([SegovPage.ReportagensIconicas]);
  }

  public scrollToId(event: string) {
    if(!this.primeiroAcesso)
      ScreenUtils.scrollToIdByResolution(event, 993);
    else this.primeiroAcesso = false;
  }

  public obterColunaExpediente(col: number) {
    return col === 0 ?
      this.dados?.expediente?.filter(x => x.ordem % 2 === 0)
      :
      this.dados?.expediente?.filter(x => x.ordem % 2 !== 0)
  }

  private getDadosSobre() {
    this.storeObterSobre.dispatch(obterSobre());
  }

  private checkResolution() {
    if (ScreenUtils.getScreenResolution() > 992)
      this.numeroItensPagina = 2;
    else
      this.numeroItensPagina = 1;
  }
}
